<!-- 加入我们 -->
<template>

    <div ref="boxheight" class="aboubox">
        <div @click="istab = false" v-show="istab" class="tabbox nobg">
            <div class="hadtabs">
                <ul>
                    <li>
                        <router-link to="/h5home">官网首页</router-link>
                    </li>
                    <li>
                        <router-link to="/h5recharge">账户充值</router-link>
                    </li>
                    <li class="active">
                        <router-link to="/h5enlist">主播招募</router-link>
                    </li>
                    <!-- <li>
                        <router-link to="/h5aboutus">关于我们</router-link>
                    </li> -->
                    <li>
                        <router-link to="/h5contactus">联系我们</router-link>
                    </li>
                </ul>
            </div>
        </div>
        <div ref="heradH" class="heradbox">
            <i class="logo"></i> <i @click="istab = true" class="tabicon"></i>
        </div>
        <div class="contentbox">
            <div class="tabs">
                <span @click="tabindex = 0" :class="tabindex == 0 ? 'active' : ''"> <i></i> 主播招募</span>
                <span @click="tabindex = 1" :class="tabindex == 1 ? 'active' : ''"> <i></i>公会招募</span>
                <span @click="tabindex = 2" :class="tabindex == 2 ? 'active' : ''"> <i></i>我们的优势</span>

            </div>
            <div :style="'height:' + contH" class="contens">
                <div v-if="tabindex == 0" class="bg1">
                    <button :data-clipboard-text="weixin" @click="copy" class="code lianxih"></button>
                </div>
                <div v-else-if="tabindex == 1" class="bg2">
                    <button :data-clipboard-text="weixin" @click="copy" class=" code lianxij"></button>
                </div>
                <div v-else-if="tabindex == 2" class="bg3"></div>

            </div>
        </div>
        <div>

        </div>

        <!-- <Footer></Footer> -->
    </div>
</template>
<script>
import Footer from "../../components/h5footer"
import Clipboard from 'clipboard'
export default {
    components: {
        Footer
    },
    data() {
        return {
            istab: false,
            tabindex: 0,
            contH: '',
            weixin: 'ynb2712',
        }
    },
    mounted() {
        this.$nextTick(() => { // 页面渲染完成后的回调
            console.log(this.$refs.boxheight.offsetHeight - 2 * this.$refs.heradH.offsetHeight)
            this.contH = (this.$refs.boxheight.offsetHeight - 2 * this.$refs.heradH.offsetHeight) + "px"
        })
    },
    created() {
        //    var heightCss =this.$refs.boxheight.offsetHeight; 
        //    console.log(heightCss)
    },
    methods: {
        copy() {
            var _this = this;
            var clipboard = new Clipboard('.code')
            clipboard.on('success', e => {
                _this.$message({ message: '已成功复制，去微信添加好友', customClass: "h5msg", type: 'success' });
                // 释放内存
                clipboard.destroy()
            })
            clipboard.on('error', e => {
                // 不支持复制
                _this.$message({ message: '该浏览器不支持自动复制', customClass: "h5msg" });
                console.log('该浏览器不支持自动复制')
                // 释放内存
                clipboard.destroy()
            })
        },
    },
}
</script>
<style lang="less" scoped>
.aboubox {
    width: 100%;
    height: 100%;
    background: #F7F7F7;
}

.contentbox {
    width: 100%;

    .tabs {
        height: 1.33rem;
        align-items: center;
        display: flex;
        width: 100%;
        font-size: .48rem;
        color: rgba(153, 153, 153, 1);
        padding: 0 .75rem;
        box-sizing: border-box;
        justify-content: space-between;

        .active {
            color: rgba(50, 51, 51, 1);
            position: relative;
        }

        .active i {
            width: .75rem;
            height: 2Px;
            border-radius: 3rem;
            background: rgba(255, 32, 94, 1);
            z-index: 5;
            position: absolute;
            bottom: -.25rem;
            left: 50%;
            transform: translateX(-50%);
        }
    }

    .contens {
        width: 100%;
        background: #fff;
        height: 80%;
        overflow-y: auto;

        .bg1 {
            background: url('https://resource.imbeiyu.com/gw/assets/images/imgaes/pic_h5_zhaomu1.png');
            background-size: 100% 100%;
            width: 100%;
            height: 26.85rem;
        }

        .bg2 {
            background: url('https://resource.imbeiyu.com/gw/assets/images/imgaes/pic_h5_zhaomu2.png');
            background-size: 100% 100%;
            width: 100%;
            height: 37.2rem;
        }

        .bg3 {
            background: url('https://resource.imbeiyu.com/gw/assets/images/imgaes/pic_h5_zhaomu3.png');
            background-size: 100% 100%;
            width: 100%;
            height: 14.4rem;
        }

        .lianxih {
            background: url('https://resource.imbeiyu.com/gw/assets/images/imgaes/btn_contact1.png');
            background-size: 100% 100%;
            width: 5.28rem;
            height: 1.28rem;
            position: fixed;
            left: 50%;
            transform: translateX(-50%);
            bottom: .6rem;
        }

        .lianxij {
            background: url('https://resource.imbeiyu.com/gw/assets/images/imgaes/btn_contact2.png');
            background-size: 100% 100%;
            width: 5.28rem;
            height: 1.28rem;
            position: fixed;
            left: 50%;
            transform: translateX(-50%);
            bottom: .6rem;
        }
    }
}

.heradbox {
    width: 100%;
    height: 1.33rem;
    background: #fff;
    position: relative;
    font-size: 0.48rem;
    color: #333333;
    line-height: 1.33rem;
    text-align: center;
    font-weight: 500;

    .logo {
        background: url('https://resource.imbeiyu.com/nnxqGw/img/h5-logo-blue2.png');
        background-size: 100% 100%;
        position: absolute;
        left: .34rem;
        top: .3rem;
        width: 3.47rem;
        height: 0.8rem;
    }

    .tabicon {
        background: url('https://resource.imbeiyu.com/gw/assets/images/h5/icon-more-black.png');
        background-size: 100% 100%;
        position: absolute;
        right: .34rem;
        top: .3rem;
        width: .7rem;
        height: .75rem;
    }
}
</style>


// WEBPACK FOOTER //
// src/page/h5page/h5enlist.vue